module.exports = __webpack_public_path__ + "img/primary_5x4_z16.c74fba94.svg";